// custom component for card with swiper gallery
class InfluencerCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    this.colorModalScheme = this.getAttribute('data-color-modal-scheme') || 'scheme-1';
    const influencer = JSON.parse(this.getAttribute('data-influencer'));
    const influencerImage = influencer.preview;
    const slug = influencer.name.toLowerCase().split(' ').join('') + Math.floor(Math.random() * 1000);
    const order = this.dataset.animationOrder || 0;
    const animate = this.dataset.animate || false;
    const cardTemplate = `
      <modal-opener class="popup-modal__opener influencer-card-opener" data-modal="#PopupModal-${slug}" > 
        <button id="Popup-${slug}"
          class="influencer-card-button ${animate ? 'scroll-trigger animate--slide-in' : ''}"
          type="button"
          style="${animate ? `--animation-order: ${order};` : ''}"
          aria-haspopup="dialog"
          >
            <article>
              <div class="img-container">
              <img src="${influencerImage}" alt="${influencer.name}" class="" loading="lazy">
              </div>
              <span>${influencer.name}</span>
            </article>
        </button>
      </modal-opener>
    `;

    const dialogTemplate = `
      <modal-dialog id="PopupModal-${slug}" class="popup-modal transition fade-in color-${this.colorModalScheme}">
        <div
          role="dialog"
          aria-label="${slug}"
          aria-modal="true"
          class="popup-modal__content fullscreen"
          tabindex="-1"
        >
          <button
              id="ModalClose-${slug}"
              type="button"
              class="popup-modal__toggle"
              aria-label="{{ 'accessibility.close' | t }}"
            >
             <i class="icon sol-icon-close"></i>
          </button>
          
          <div class="popup-modal__content-gallery">
            <span class="popup-modal__content-gallery-header">
                <h3>${influencer.name}</h1>
            </span>
            <div class="popup-modal__content-gallery-body">
              <swiper-container 
                data-id="${slug}" 
                class="swiper-container"
                data-slides-per-view="1"
                data-mobile-slides-per-view="1"
                data-loop="true"
                data-stop-video="true"
              >
                <div class="swiper-wrapper">
                  ${influencer.gallery
                    .map(
                      (media) => `
                        <div class="swiper-slide">
                          ${
                            media.mediaType === 'video'
                              ? `<video-thumbnail data-video-src="${media.url}"></video-thumbnail>`
                              : `<img src="${media.url}" alt="${influencer.name}" loading="lazy" />`
                          }
                        </div>
                      `
                    )
                    .join('')}
                    
                  </div>
                    <div class="swiper-button-prev swiper-button-nav"><span></span></div>
                    <div class="swiper-button-next swiper-button-nav"><span></span></div>
                </swiper-container>
              </div>
            </div>
        </div>
      </modal-dialog>
    `;

    this.innerHTML = cardTemplate;
    document.querySelector('.influencers-container').insertAdjacentHTML('beforeend', dialogTemplate);
  }
}

customElements.define('influencer-card', InfluencerCard);

class InfluencerGrid extends HTMLElement {
  constructor() {
    super();
    this.skeletonGrid = this.innerHTML;
    this.influencers = [];
  }

  connectedCallback() {
    console.log('data', this.dataset);
    this.colorModalScheme = this.dataset.colorModalScheme || 'scheme-1';
    this.animateCards = this.dataset.animateCards || false;
    this.paginatorId = this.dataset.paginatorId;
    const searchParams = new URLSearchParams(window.location.search);
    this.page = searchParams.get('page') || 1;
    this.search = searchParams.get('q') || '';
    this.limit = this.dataset.limit || 12;
    this.total = 0;
    this.initGrid();
  }

  initGrid() {
    this.url = this.dataset.apiUrl;
    const { search, page } = this;
    this.fetchAndRenderInfluencers(search, page).then((r) => {});
    //this.addEventListeners();
  }

  renderSkeleton(withPaginator = false) {
    this.innerHTML = this.skeletonGrid;
    if (withPaginator) {
      const paginator = document.querySelector(`#${this.paginatorId}`);
      if (paginator) {
        paginator.renderSkeletons();
      }
    }
  }

  renderGrid(influencers) {
    const gridColumnsDesktop = this.dataset.gridColumnsDesktop || 4;
    const gridColumnsTablet = this.dataset.gridColumnsTablet || 3;
    const gridColumnsMobile = this.dataset.gridColumnsMobile || 2;
    const makeGrid = (influencers) => {
      const grid = document.createElement('div');
      grid.classList.add('influencers-grid');
      grid.classList.add('grid');
      grid.classList.add('grid--' + gridColumnsDesktop + '-col-desktop');
      grid.classList.add('grid--' + gridColumnsTablet + '-col-tablet');
      grid.classList.add('grid--' + gridColumnsMobile + '-col');
      if (influencers.length === 0) {
        const noResults = document.createElement('div');
        noResults.classList.add('no-results');
        noResults.innerHTML = '404';
        return noResults;
      } else {
        influencers.forEach((influencer, index) => {
          grid.appendChild(makeCard(influencer, index));
        });
      }
      return grid;
    };

    const makeCard = (influencer, index) => {
      const card = document.createElement('influencer-card');
      card.classList.add('influencer-card');
      card.classList.add('grid__item');
      card.setAttribute('data-influencer', JSON.stringify(influencer));
      card.setAttribute('data-color-modal-scheme', this.colorModalScheme);
      if (this.animateCards) {
        card.setAttribute('data-animate', 'true');
        card.setAttribute('data-animation-order', index);
      }
      return card;
    };

    this.innerHTML = '';
    const grid = makeGrid(influencers);
    this.appendChild(grid);
    // necesito que siempre se suba a la posision top
  }

  async fetchAndRenderInfluencers(search, page) {
    async function fetchInfluencers(url, params) {
      return fetch(url + '?' + new URLSearchParams(params).toString())
        .then((response) => response.json())
        .then((data) => {
          return data;
        })
        .catch((error) => {
          console.error('Error fetching influencers:', error);
        });
    }

    function parseInfluencers(items) {
      return items
        .map((item) => {
          const influencer = item.influencer;
          return {
            name: influencer.profile?.nickname || '',
            gallery: influencer.gallery.map((media) => ({
              mediaType: media.type,
              url: media.url,
            })),
            preview: influencer.gallery.length ? influencer.gallery[0].url : '',
            order: item.order,
          };
        })
        .filter((influencer) => influencer.nickname !== '' && influencer.gallery.length > 0);
    }
    const params = { limit: this.limit, page };
    if (search) {
      params.search = search;
    }
    const rawData = await fetchInfluencers(this.url, params);
    const influencers = parseInfluencers(rawData.data.items);
    const totalPages = rawData.data.total;
    this.setTotal(totalPages);
    this.renderGrid(influencers);
  }

  setTotal(total) {
    this.total = total;
    const paginator = document.querySelector(`#${this.paginatorId}`);
    if (paginator) {
      const totalPages = Math.ceil(total / this.limit);
      paginator.setTotalPages(totalPages, this.page);
    }
  }

  searchQuery(query) {
    this.renderSkeleton(true);
    this.page = 1;
    this.search = query;
    this.fetchAndRenderInfluencers(this.search, this.page);
  }
}

customElements.define('influencer-grid', InfluencerGrid);
class InfluencerStaticGallery extends InfluencerGrid {
  constructor() {
    super();
  }

  //custom InitGrid to render skeleton
  initGrid() {
    this.renderSkeleton();
  }
  setInfluencers(data) {
    if (!data) {
      return;
    }
    if (this.search) {
      this.influencers = this.filterSearch(data, this.search);
      const paginateInfluencers = this.paginateInfluencers(this.influencers, this.page, this.limit);
      this.renderGrid(paginateInfluencers);
    } else {
      this.influencers = data;
      this.setTotal(this.influencers.length, this.page);
      const paginateInfluencers = this.paginateInfluencers(this.influencers, this.page, this.limit);
      this.renderGrid(paginateInfluencers);
    }
  }
  filterSearch(influencers, search, page) {
    const filteredInfluencers = [...influencers].filter((influencer) => {
      return influencer.name.toLowerCase().includes(search.toLowerCase());
    });
    this.setTotal(filteredInfluencers.length, page);
    return filteredInfluencers;
  }
  paginateInfluencers(influencers, page, limit) {
    return [...influencers].slice((page - 1) * limit, page * limit);
  }

  searchQuery(query) {
    this.renderSkeleton(true);
    this.page = 1;
    this.search = query;
    const data = this.filterSearch(this.influencers, query, this.page, this.limit);
    const dataPaginated = this.paginateInfluencers(data, this.page, this.limit);
    this.renderGrid(dataPaginated);
  }
}

customElements.define('influencer-static-grid', InfluencerStaticGallery);
class searchInfluencers extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const searchParams = new URLSearchParams(window.location.search);
    this.anchor = this.dataset.anchor || '';
    this.search = searchParams.get('q') || '';
    this.initRender();
    this.addEventListeners();
  }

  initRender() {
    const searchInput = this.querySelector('.search-form .search-input input');
    if (this.search && searchInput) {
      searchInput.value = this.search;
    }
  }

  addEventListeners() {
    //remove submit event default
    this.querySelector('.search-form').addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();
      searchInfluencers();
    });

    const searchInput = this.querySelector('.search-form .search-input input');
    const resetButton = this.querySelector('.search-form button[type="reset"]');
    const influencersGallery = this.anchor ? document.querySelector(`#${this.anchor}`) : null;

    // change url whitout reload
    function changeUrl(search) {
      const params = new URLSearchParams();
      if (search) {
        params.set('q', search);
      } else {
        params.delete('q');
      }
      history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
    }
    function searchInfluencers() {
      changeUrl(searchInput.value);
      if (influencersGallery) {
        influencersGallery.searchQuery(searchInput.value);
      }
    }
    resetButton.addEventListener('click', () => {
      searchInput.value = '';
      searchInfluencers();
    });
  }
}

customElements.define('search-influencers', searchInfluencers);
